import { Alert, Button, Dialog, DialogContent, DialogActions } from '@mui/material'
import { useAtom, useSetAtom } from 'jotai'
import { useNavigate } from 'react-router-dom'
import { cancelDialogAtom, nonblockAtom } from 'store/commonAtoms'


export const CancelDialog = () => {
    const [to, setTo] = useAtom(cancelDialogAtom)
    const navi = useNavigate()
    const setNonblock = useSetAtom(nonblockAtom)

    const handleYes = () => {
        setNonblock(true)
        navi(to)
        setTo(null)
    }

    return (
        <Dialog
            open={!!to}
            closeAfterTransition={true}
            disableRestoreFocus={true}
            onClose={() => setTo(null)}
        >
            <DialogContent>
                <Alert severity="warning">入力内容がキャンセルされますが、よろしいですか？</Alert>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setTo(null)} variant="outlined" sx={{ minWidth : 100 }}>いいえ</Button>
                <Button onClick={handleYes} variant="contained" sx={{ minWidth : 100 }}>はい</Button>
            </DialogActions>
        </Dialog>
    )
}
    
export default CancelDialog
